import { h, Host } from '@stencil/core';
export class PortalComponent {
  constructor() {
    this.reference = undefined;
    this.isOpen = false;
  }
  didPopupClose() {
    this.closeDialog();
  }
  closeDialog() {
    this.isOpen = false;
  }
  render() {
    return (h(Host, null, h("se-dialog", { open: this.isOpen, size: "small", noBackdrop: true, pageScroll: false, color: "alternative" }, h("se-dialog-header", { "close-icon": "true", color: "alternative", padding: "small" }), h("se-dialog-content", { color: "alternative", padding: "none" }, h("div", { class: "tooltip-wrapper-modal-content" }, h("slot", { name: "tooltip-content" }))))));
  }
  static get is() { return "pes-sustainability-portal"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["sustainability-portal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["sustainability-portal.css"]
    };
  }
  static get properties() {
    return {
      "reference": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "HTMLElement",
          "resolved": "HTMLElement",
          "references": {
            "HTMLElement": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isOpen": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-open",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get listeners() {
    return [{
        "name": "didCloseDialog",
        "method": "didPopupClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "didClose",
        "method": "didPopupClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
